import styled from 'styled-components'
import { theme } from '../../styles'

export const CardPreview = styled.div`
  position: relative;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: 160px;
  padding: 20px 22px;
  margin-bottom: 22px;
  border-radius: 14px;
  color: ${theme.cores.white};
  background: linear-gradient(135deg, ${theme.cores.navy} 0%, ${theme.cores.navy700} 55%, #3A4796 100%);
  box-shadow: ${theme.sombras.md};

  &::after {
    content: '';
    position: absolute;
    right: -50px;
    bottom: -60px;
    width: 180px;
    height: 180px;
    border-radius: 50%;
    background: repeating-radial-gradient(circle, rgba(255, 255, 255, 0.06) 0 1px, transparent 1px 8px);
  }
`

export const CardBrand = styled.div`
  position: absolute;
  top: 20px;
  right: 22px;
  z-index: 2;
  font-weight: 800;
  font-style: italic;
  font-size: 18px;
  letter-spacing: 0.02em;
  color: ${theme.cores.white};
`

export const CardChip = styled.div`
  position: relative;
  z-index: 2;
  width: 42px;
  height: 31px;
  border-radius: 6px;
  background: linear-gradient(135deg, #E7C66B, #C9A23E);
`

export const CardNumber = styled.div`
  position: relative;
  z-index: 2;
  font-family: ${theme.fontes.serif};
  font-size: 22px;
  letter-spacing: 0.12em;
  font-variant-numeric: tabular-nums;
`

export const CardRow = styled.div`
  position: relative;
  z-index: 2;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  gap: 20px;
`

export const CardCol = styled.div`
  display: flex;
  flex-direction: column;
  gap: 3px;
`

export const CardKey = styled.div`
  font-size: 9.5px;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: ${theme.cores.whiteAlpha60};
`

export const CardValue = styled.div`
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 0.04em;
  color: ${theme.cores.white};
  font-variant-numeric: tabular-nums;
`
